import { useEffect, useRef, useState } from "react";

import BottomSubmit from "../../components/BottomSubmit";
import ConfigLoader from "../../components/ConfigLoader";

import './styles.css'

import api from '@helpers/api'

import ImageImportTool from "@components/ImageImportTool/index.js";

import { Button, Input, Text } from "@fragments";

import { AddRounded, CheckRounded, DeleteRounded, EditRounded, InsertPhotoRounded, LinkRounded, VrpanoRounded } from "@mui/icons-material";

import { useCommunity } from "contexts/community";

import { useParams } from "react-router-dom";


export default function General({ info }) {
    const [hasUpdates, setHasUpdates] = useState(false)
    const [loading, setLoading] = useState(true)

    let { slug } = useParams();

    const { loading: communityLoading, community } = useCommunity();

    const REF_config = useRef()


    useEffect(() => {
        if (!communityLoading) handleLoad(true)
    }, [communityLoading])

    async function handleLoad() {
        if (info) {
            REF_config.current = { ...info }
            setLoading(false)
        }
    }
    async function handleSubmit() {
        try {
            const payload = getPayload();
            if (!payload) return; // Se a validação falhar, não continua

            const { data } = await api.post('community/settings/general', payload)

            if (data?.id) {
                window.setSnackbar('Alterações salvas')
                setHasUpdates(false)
            } else {
                window.setSnackbar('Houve um erro ao salvar as alterações, tente novamente mais tarde')
            }

        } catch (e) {
            console.log(e)
            window.setSnackbar('Houve um erro ao salvar as alterações, tente novamente mais tarde')
        }

        function getPayload() {
            const config = REF_config.current;
            const payload = {
                id: community.getBySlug(slug).id
            };

            // Validação do nome (obrigatório, 3-25 caracteres)
            if (!config.name || config.name.trim().length === 0) {
                window.setSnackbar('O nome da comunidade é obrigatório');
                return null;
            }

            const nameLength = config.name.trim().length;
            if (nameLength < 3 || nameLength > 25) {
                window.setSnackbar('O nome da comunidade deve ter entre 3 e 25 caracteres');
                return null;
            }

            payload.name = config.name.trim();

            // Descrição (opcional)
            if (config.description && config.description.trim().length > 0) {
                payload.description = config.description.trim();
            }

            // Links (opcional, máximo 5 itens)
            if (config.links && config.links.length > 0) {
                if (config.links.length > 5) {
                    window.setSnackbar('Você pode adicionar no máximo 5 links');
                    return null;
                }
                payload.links = config.links;
            }

            // Banner (opcional)
            if (config.banner_base64) {
                payload.banner_base64 = config.banner_base64;
            }

            // Hero (opcional)
            if (config.hero_base64) {
                payload.hero_base64 = config.hero_base64;
            }

            return payload;
        }
    }

    function handleChange(key, value) {
        REF_config.current[key] = value
        setHasUpdates(true)
    }

    function Hero() {
        const [hero, setHero] = useState(
            REF_config.current.hero_base64 ||
            REF_config.current.hero
        );

        return (
            <>
                <Text.h3
                    value="Banner"
                    left={<VrpanoRounded />}
                />
                <Text.h4
                    contrast={5}
                    value="Adicione um banner no tamanho 1600px por 300px (16:3)"
                />
                <ImageImportTool
                    className="mt-2"
                    variant="dark"
                    aspectRatio={16 / 3}
                    src={hero}
                    imageMaxWidth={1700}
                    onCrop={(imageBase64) => {
                        handleChange('hero_base64', imageBase64)
                        setHero(imageBase64);
                    }}
                    title="Redimensionar capa da comunidade"
                />
            </>
        )
    }

    function Profile() {
        const [image, setImage] = useState(
            REF_config.current.banner_base64 ||
            REF_config.current.banner_url ||
            REF_config.current.banner
        );

        return (
            <>
                <Text.h3
                    value="Foto de perfil"
                    left={<InsertPhotoRounded />}
                    className="mt-4 mb-2"
                />
                <Text.h5
                    contrast={5}
                    value="Adicione uma foto de perfil no tamanho 720px por 720px (1:1)"
                />
                <ImageImportTool
                    className="mt-2 upload-banner"
                    variant="dark"
                    src={image}
                    size={135}
                    onCrop={(imageBase64) => {
                        handleChange('banner_base64', imageBase64)
                        setImage(imageBase64);
                    }}
                    title="Redimensionar banner da comunidade"
                />
            </>
        )
    }

    function Links() {
        const [links, setLinks] = useState(REF_config.current.links)

        const LinkInfo = ({ data, index }) => {
            const [open, setOpen] = useState(!!data.open);
            const [title, setTitle] = useState(data.title);
            const [link, setLink] = useState(data.url);

            useEffect(() => {
                REF_config.current.links[index].open = open;
            }, [open]);

            if (!open)
                return (
                    <div className="description-link-row">
                        <div className="description-link bsf-9">
                            <LinkRounded className="url-icon" />
                            <span className="title">{title || <i>(Não configurado)</i>}</span>
                            <span className="url">{link}</span>
                            <Button
                                color="overlay"
                                onClick={() => setOpen(true)}
                                size="small"
                                icon={<EditRounded />}
                            />
                        </div>
                    </div>
                );

            return (
                <div className="link-info-block mt-2 mb-3 px-2 py-2">
                    <Input.Text
                        autoFocus
                        emoji
                        variant="dark"
                        size={25}
                        value={title}
                        onInput={(value) => {
                            const linkCopy = [...links];
                            linkCopy[index].title = value;
                            REF_config.current.links = [...linkCopy];
                            setTitle(value);
                        }}
                        label="Título do link"
                        placeholder="O título do link será o texto do botão no app"
                    />
                    <Input.Text
                        start="https://"
                        variant="dark"
                        size={180}
                        value={link}
                        onInput={(value) => {
                            const linkCopy = [...links];
                            linkCopy[index].url = value;
                            REF_config.current.links = [...linkCopy];
                            setLink(value);
                        }}
                        label="Link"
                        placeholder="https://seusite.com"
                    />
                    <div className="mt-1 link-buttons-footer">
                        <Button
                            color="error"
                            onClick={() => {
                                const linkCopy = [...links];
                                linkCopy.splice(index, 1);
                                REF_config.current.links = [...linkCopy];
                                setLinks([...linkCopy]);
                            }}
                            endIcon={<DeleteRounded />}
                            text={"Excluir"}
                        />
                        <Button
                            color="overlay"
                            onClick={() => {
                                setOpen(false);
                            }}
                            endIcon={<CheckRounded />}
                            text={"Concluir edição"}
                        />
                    </div>
                </div>
            );
        };

        const linksElm =
            links?.length > 0 ? (
                <>
                    {links?.map((linkInfo, i) => (
                        <LinkInfo data={linkInfo} key={i} index={i} />
                    ))}
                </>
            ) : null;

        return (
            <div>
                <Text.h3
                    value="Links na descrição"
                    className="mt-4 mb-2"
                    left={<LinkRounded />}
                    grow
                    right={<Button
                        color="white"
                        variant="rounded"
                        onClick={() => {
                            const linksCopy = [...(links || [])];
                            linksCopy.push({ title: "", url: "", open: true });
                            handleChange('links', linksCopy)
                            setLinks([...linksCopy]);
                        }}
                        small
                        disabled={links?.length >= 3}
                        endIcon={<AddRounded />}
                        text="Adicionar link"
                    />}
                />
                {linksElm}
            </div >
        );
    }

    return (
        <div className="config-page config-general-community mt-5" key={loading}>
            <h2>Configurações gerais da comunidade</h2>

            {loading ? <ConfigLoader /> : (
                <div className="mt-4">
                    <Input.Text
                        variant="dark"
                        className="mt-2"
                        label="Nome da comunidade"
                        size={25}
                        value={REF_config.current.name}
                        onInput={(v) => {
                            handleChange('name', v)
                        }}
                    />
                    <Input.Text
                        variant="dark"
                        className="mt-2"
                        label="Descrição (opcional)"
                        size={250}
                        multiline
                        value={REF_config.current.description}
                        onInput={(v) => {
                            handleChange('description', v)
                        }}
                        emoji
                    />

                    <Hero />

                    <Profile />

                    <Links />
                </div>
            )
            }

            {hasUpdates && <BottomSubmit onPress={handleSubmit} />}
        </div >
    )
}